module.exports = __webpack_public_path__ + "img/sellers.a0edec86.svg";